import { render, staticRenderFns } from "./MintalMesPrdCraftList.vue?vue&type=template&id=79e65245&"
import script from "./MintalMesPrdCraftList.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdCraftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports